import { Stack, Box } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { ButtonLink } from "Components/Shared/ButtonLink";
import { appUrl } from "Utils/UrlUtils";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

const RESOURCES = Resources.Components.Affiliate.UserAffiliate;

export const MooneLiteWarning = () => {
  const { t } = useResource();

  return (
    <Stack border="1px solid red" borderRadius={2} p={[3, 4]} gap={4}>
      <Box display="flex" alignItems="center" gap={3}>
        <WarningAmberOutlinedIcon
          sx={({ palette }) => ({
            color: palette.error.main,
            width: 35,
            height: 35,
          })}
        />
        <ErrorText>{t(RESOURCES.MooneLiteWarning)}</ErrorText>
      </Box>
      <ButtonLink
        color="primary"
        variant="contained"
        link={appUrl("complete-customer-onboarding")}
        text={t(Resources.Components.MooneLitePopup.CompleteRegistrationButton)}
        endIcon={<ExitToAppIcon />}
      />
    </Stack>
  );
};
